// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React, { useEffect } from 'react'
import { ReactComponent as PrivacyIcon } from '../../../../static/images/PrivacyIcon.svg'
import './FooterAI.scss'

declare const window: any

const FooterAI: React.FC = () => {
  const siteUrls = [
    {
      title: process.env.LANDING_LONG_NAME,
      childrenUrls: [
        { key: 'Products', href: '/products' },
        { key: 'Contact', href: process.env.CONTACT_SALES_URL }
      ]
    },
    {
      title: 'Solutions',
      childrenUrls: [
        { key: 'Enterprise', href: '/solutions/enterprise' },
        { key: 'Developers', href: '/solutions/developers' },
        { key: 'Startups', href: '/solutions/startups' }
      ]
    },
    {
      title: 'Resources',
      childrenUrls: [
        { key: 'Documentation', href: process.env.DOCUMENTATION_URL },
        { key: 'Tutorials', href: process.env.TUTORIALS_URL },
        { key: 'Learning events', href: process.env.LEARNING_EVENTS }
      ]
    },
    {
      title: 'Support',
      childrenUrls: [
        { key: 'Support Channels', href: process.env.CONTACT_SUPPORT_URL },
        { key: 'Privacy', href: process.env.PRIVACY_URL, 'data-cookie-notice': 'true' },
        { key: 'Terms of use', href: process.env.TERMS_OF_USE_URL },
        { key: 'Trademarks', href: process.env.TRADEMARKS_URL },
        {
          key: 'Cookies',
          href: process.env.COOKIES_URL,
          'data-cookie-notice': true,
          onClick: (e: any) => {
            e.preventDefault()
            if (window?.wap_tms && window?.wap_tms.consent && window?.wap_tms.consent.openConsentMenu) {
              window?.wap_tms.consent.openConsentMenu()
            }
          }
        },
        { key: 'Supply chain transparency', href: process.env.SUPPLY_CHAIN_TRANSPARENCY_URL },
        { key: 'Sitemap', href: process.env.SITEMAP_URL },
        {
          key: (
            <>
              Your privacy choices <PrivacyIcon />
            </>
          ),
          href: '/#',
          id: 'wap_dns',
          className: 'gap-s3',
          'data-wap_ref': 'dns',
          onClick: (e: any) => {
            e.preventDefault()
            if (window?.wap_tms && window?.wap_tms.consent && window?.wap_tms.consent.openConsentMenu) {
              window?.wap_tms.consent.openConsentMenu()
            }
          }
        },
        {
          key: 'Notice at collection',
          href: process.env.NOTICE_AT_COLLECTION_URL,
          'data-wap_ref': 'nac',
          id: 'wap_nac'
        }
      ]
    }
  ]

  useEffect(() => {
    if (window?.wap_tms && window?.wap_tms.consent && window?.wap_tms.consent.enablePrivacyLinks) {
      window?.wap_tms.consent.enablePrivacyLinks()
    }
  }, [])

  return (
    <footer className="footer-container">
      <div className="internal-container p-s10 gap-s10">
        <div className="footer-content-container gap-s10 p-s0">
          <div>
            <a href="/" aria-label="Home">
              <img src={'/images/tiber-logo.svg'} alt={process.env.LANDING_LONG_NAME?.toString() ?? ''} />
            </a>
          </div>
          {siteUrls.map((item: any) => (
            <div key={item.title} className="footer-links-container px-s6 gap-s4">
              <span className="h6">{item.title}</span>
              {item.childrenUrls.map((item: any) => (
                <a key={item.key} {...item} rel="noreferrer">
                  {item.key}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="w-100">
          <a href="https://www.intel.com/" className="footerLinkSmall" rel="noreferrer">
            {process.env.COMPANY_LONG_NAME}
          </a>
        </div>
      </div>
    </footer>
  )
}

export default FooterAI
